document.addEventListener('DOMContentLoaded', function() {
  let form = document.querySelector('._js-registry-filter-form');
  if (form) {
    checkInputs(form);
  }

  function setCaptcha() {
    if (!window.smartCaptcha) {
      return;
    }

    if (!window.captcha_key_site) {
      return;
    }

    return window.smartCaptcha.render('captcha-container', {
      sitekey: window.captcha_key_site,
      invisible: true, // Сделать капчу невидимой
      callback: registryHandler
    });
  }
  let registryCaptchaId = setCaptcha();


  function registryHandler() {
    if (!form) {
      return;
    }

    if (!window.smartCaptcha) {
      return;
    }

    let registryContainer = document.querySelector('._js-registry-result');
    if (!registryContainer) {
      return;
    }

    let data = new FormData(form);
    let dataArray = {};
    let nextPage = 1;
    let wholeBlock = true;

    data.forEach(function(value, key) {
      dataArray[key] = value;
    });
    let nexPageInput = form.querySelector('._js-registry-page-number-input');
    if (nexPageInput) {
      nextPage = nexPageInput.value;
    }

    if (parseInt(nextPage) > 1) {
      wholeBlock = false;
    }
    registryContainer?.classList.add('_disabled');

    getRegistryList(dataArray, nextPage)
        .then(res => {
          if (res.data.html) {
            updateRegistryDOM(res.data.html, registryContainer, wholeBlock);
          }
        })
        .catch(error => console.error('Ошибка загрузки контента:', error))
        .finally(() => {
          registryContainer?.classList.remove('_disabled');
          window.smartCaptcha.reset(registryCaptchaId);
        });
  }

  document.addEventListener('input', function (e) {
    let target = checkEventTarget(e, '._js-registry-form-input');
    if (!target) {
      return;
    }
    let form = target.closest('form');
    checkInputs(form);
  });

  document.addEventListener('click', function(e) {
    let target = checkEventTarget(e, '._js-registry-more');
    if (!target) {
      return;
    }
    if (!form) {
      return;
    }

    let registryContainer = target.closest('._js-registry-result');

    if (!registryContainer) {
      return;
    }

    let nextPage = target.dataset.next;
    let nexPageInput = form.querySelector('._js-registry-page-number-input');
    if (nexPageInput) {
      nexPageInput.value = nextPage;
    }

    if (!window.smartCaptcha) {
      return;
    }

    window.smartCaptcha.execute(registryCaptchaId);
  });

  document.addEventListener('submit', function (e) {
    let target = checkEventTarget(e, '._js-registry-filter-form');
    if (!target) {
      return;
    }
    e.preventDefault();

    if (!form) {
      return;
    }

    let registryContainer = document.querySelector('._js-registry-result');
    if (!registryContainer) {
      return;
    }

    let nextPage = 1;
    let nexPageInput = form.querySelector('._js-registry-page-number-input');

    if (nexPageInput) {
      nexPageInput.value = nextPage;
    }

    if (!window.smartCaptcha) {
      return;
    }

    window.smartCaptcha.execute(registryCaptchaId);

  });

  const maskSnils = document.querySelector('._js-mask-snils');
  maskSnils?.addEventListener('input', function() {
    this.value = formatSnils(this.value);
  });

  function formatSnils(value) {
    const numbers = value.replace(/\D/g, '');

    return numbers
      .split('')
      .reduce(function(acc, digit, index) {
        if (index !== 0 && index % 3 === 0 && index <= 9) {
          acc += '-';
        }
        return acc + digit;
      }, '');
  }
});

function updateRegistryDOM(resHTML, blockDOM, wholeBlock = false) {
  let answerDOM = getDocumentObjectFromHtmlString(resHTML, false);
  if (answerDOM) {
    if (wholeBlock) {
      blockDOM.innerHTML = answerDOM.innerHTML;
      scrollToNode(blockDOM);
    } else {
      let elementsListInDOM = blockDOM.querySelector('._js-registry-list');
      let elementsListInAnswer = answerDOM.querySelector('._js-registry-list');
      let paginationInDOM = blockDOM.querySelector('._js-registry-more');
      let paginationInAnswer = answerDOM.querySelector('._js-registry-more');

      if (elementsListInAnswer) {
        let elements = elementsListInAnswer.querySelectorAll('._js-registry-element');
        if (elements) {
          elements.forEach(element => {
            elementsListInDOM.appendChild(element.cloneNode(true));
          })
        }
      }
      if (paginationInDOM && paginationInAnswer) {
        paginationInDOM.parentNode.replaceChild(paginationInAnswer, paginationInDOM);
      } else {
        paginationInDOM.parentNode.removeChild(paginationInDOM);
      }
    }
  }
}

function checkInputs(form) {
  let isAnyFieldFilled = false;
  let inputs = form.querySelectorAll('input[type=text]');
  let btn = form.querySelector('button[type=submit]')
  if (inputs) {
    inputs.forEach(input => {
      if (input.value.trim() !== '') {
        isAnyFieldFilled = true;
      }
    });

    if (isAnyFieldFilled) {
      btn.removeAttribute("disabled");
    } else {
      btn.setAttribute("disabled", "");
    }
  }

}